import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Form, InputForm, Validation } from "../../components/Form";
import { AutocompleteMulti } from "../../components/Autocomplete";
import { BasePaper, Row } from "../../components/Base";
import Button from "../../components/Button";
import { getObservables } from "../../api/observable";
import { StyledSwitch } from "../../components/Base";
import {
  getActivitiesTrainingById,
  createActivitiesTraining,
  updateActivitiesTraining,
} from "../../api/activities-training";

const EditActivitiesTraining = ({ match, history }) => {
  const { t } = useTranslation();
  const { activitiesTrainingId } = match.params;
  const isAdd = !activitiesTrainingId;
  const [activitiesTraining, setActivitiesTraining] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [Observables, setObservables] = useState([]);
  const [selectedObservable, setSelectedObservable] = useState([]);
  const [selectedStatus, setStatus] = useState("active");

  useEffect(() => {
    (async () => {
      const observables = await getObservables();
      setObservables(observables);
      if (activitiesTrainingId) {
        const activitiesTrainingRes = await getActivitiesTrainingById(activitiesTrainingId);
        setActivitiesTraining(activitiesTrainingRes);
        setStatus(activitiesTrainingRes.status);
        setSelectedObservable(activitiesTrainingRes.observable || []);
      }
      setLoaded(true);
    })();
  }, [activitiesTrainingId]);

  const goBack = () => history.goBack();

  const onSubmit = async (values) => {
    values.status = selectedStatus;
    const observablesIds = selectedObservable.map((c) => c.id);

    let result;
    if (isAdd) {
      result = await createActivitiesTraining(values, observablesIds);
    } else {
      result = await updateActivitiesTraining(activitiesTrainingId, values, observablesIds);
    }
    if (result.ok) {
      history.push("/activities-training");
    }
  };

  const title = isAdd ? t("activities_training.add_title") : t("activities_training.edit_title");

  return (
    <>
      <Typography variant="h4">
        <Button icon={<ArrowBackIcon />} onClick={goBack} />
        {title}
      </Typography>
      {loaded ? (
        <BasePaper>
          <Form
            defaultValues={{
              name: activitiesTraining?.name,
            }}
            validation={{
              name: Validation.required,
            }}
            onSubmit={onSubmit}
          >
            <Row>
              <InputForm name="name" label={t("activities_training.name_required")} />
            </Row>

            <Row>
              <AutocompleteMulti
                label={t("activities_training.observables_list")}
                options={Observables}
                value={selectedObservable}
                onChange={(items) => {
                  setSelectedObservable(items);
                }}
              />
            </Row>
            <Row>
              {t("status")}{" "}
              <StyledSwitch
                title={t("activities_training.change_status")}
                checked={selectedStatus === "active"}
                onChange={() => setStatus(selectedStatus === "active" ? "passive" : "active")}
              />
            </Row>

            <Row>
              <Button type="submit">{t("save")}</Button>
              <Button onClick={goBack}>{t("cancel")}</Button>
            </Row>
          </Form>
        </BasePaper>
      ) : null}
    </>
  );
};

export default EditActivitiesTraining;
